import { render } from "./InfoWindowArrivedFleet.vue?vue&type=template&id=45e24f65"
import script from "./InfoWindowArrivedFleet.vue?vue&type=script&lang=js"
export * from "./InfoWindowArrivedFleet.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__